import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'strtoarray'
})
export class StrtoarrayPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    if (value != undefined && value != '' && value != null) {
      const array = JSON.parse(value);
      return Array.isArray(array) ? array.join(', ') : ''
    } else {
      return value
    }
  }

}
